export class UserIndikatorenUeberkategorieFilter {
  idIndikatorRichtungen!: Number[];
  lebensabschnitt!: String[];
  dimensionDesTierwohls!: String[];
  indikatorart!: String[];
  idsUeberkategorienFilter!: Number[];
}
